import React from 'react';
import { TileArticle } from './TileArticle';
import { themeFor, iconFor } from './manualTheme';

export const ManualChapter = ({ section, tiles, full, index }) => {
  const theme = themeFor(section.colour);
  const Icon = iconFor(section.icon);
  return (
    <section id={`chapter-${section.id}`} data-testid={`help-chapter-${section.id}`} className={`rounded-2xl border ${theme.tint} p-4 sm:p-6 scroll-mt-28 print-break`}>
      <header className="flex items-center gap-3">
        <span className={`inline-flex items-center justify-center w-9 h-9 rounded-lg ${theme.accent} text-white shrink-0`}><Icon className="w-5 h-5" /></span>
        <div className="min-w-0">
          <div className={`text-[11px] font-bold uppercase tracking-widest ${theme.text}`}>{index != null ? `Chapter ${index}` : 'Guide'}</div>
          <h3 className="text-xl sm:text-2xl font-bold text-[#27292E] leading-tight">{section.title}</h3>
          {section.intro && <p className="text-sm text-gray-700 mt-1">{section.intro}</p>}
        </div>
      </header>
      <div className="mt-4 grid gap-3">
        {tiles.map((t) => <TileArticle key={t.id} tile={t} full={full} theme={theme} />)}
      </div>
    </section>
  );
};
